import React, { createContext, useContext, ReactNode } from 'react';
import { useMaintenanceTypes, MaintenanceType } from '@/components/hooks/useMaintenanceTypes';
import { useMaintenanceRecords, MaintenanceRecord } from '@/components/hooks/useMaintenanceRecords';

interface MaintenanceContextType {
    types: MaintenanceType[];
    loadingTypes: boolean;
    addType: (name: string, intervalKm: number, icon?: string) => Promise<MaintenanceType | null>;
    deleteType: (id: string) => Promise<void>;
    refreshTypes: () => Promise<void>;

    records: MaintenanceRecord[];
    loadingRecords: boolean;
    addRecord: (maintenanceTypeId: string, mileageKm: number, cost?: number, notes?: string, performedAt?: string) => Promise<MaintenanceRecord | null>;
    getLastRecordForType: (typeId: string) => MaintenanceRecord | undefined;
    refreshRecords: () => Promise<void>;
}

const MaintenanceContext = createContext<MaintenanceContextType | null>(null);

export const MaintenanceProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const { types, loading: loadingTypes, addType, deleteType, refresh: refreshTypes } = useMaintenanceTypes();
    const { records, loading: loadingRecords, addRecord, getLastRecordForType, refresh: refreshRecords } = useMaintenanceRecords();

    return (
        <MaintenanceContext.Provider value={{
            types,
            loadingTypes,
            addType,
            deleteType,
            refreshTypes,
            records,
            loadingRecords,
            addRecord,
            getLastRecordForType,
            refreshRecords
        }}>
            {children}
        </MaintenanceContext.Provider>
    );
};

export const useMaintenance = () => {
    const context = useContext(MaintenanceContext);
    if (!context) {
        throw new Error('useMaintenance must be used within a MaintenanceProvider');
    }
    return context;
};
